import { jsx } from "theme-ui";
import React, { Fragment, forwardRef, SVGAttributes } from "react";

type PathProps = SVGAttributes<SVGPathElement>;

const ChevronDown = (props: PathProps) => (
  <path
    d="M3.388,7.5l5.1-5.1a1.4,1.4,0,0,0,0-1.985h0a1.4,1.4,0,0,0-1.984,0l-6.1,6.1h0a1.4,1.4,0,0,0,0,1.985l6.1,6.1a1.4,1.4,0,0,0,1.984,0h0a1.4,1.4,0,0,0,0-1.985Z"
    transform="translate(0 8.904) rotate(-90)"
    {...props}
  />
);
const ChevronUp = (props: PathProps) => (
  <path
    d="M3.388,7.5l5.1-5.1a1.4,1.4,0,0,0,0-1.985h0a1.4,1.4,0,0,0-1.984,0l-6.1,6.1h0a1.4,1.4,0,0,0,0,1.985l6.1,6.1a1.4,1.4,0,0,0,1.984,0h0a1.4,1.4,0,0,0,0-1.985Z"
    transform="translate(0 8.904) rotate(90)"
    {...props}
  />
);
const ChevronRight = (props: PathProps) => (
  <path
    d="M1.818 0L-.001 1.817l5.895 5.895-5.893 5.893 1.819 1.819 7.712-7.712z"
    {...props}
  />
);
const Home = (props: PathProps) => (
  <path
    d="M 16 2.59375 L 15.28125 3.28125 L 2.28125 16.28125 L 3.71875 17.71875 L 5 16.4375 L 5 27 L 5 28 L 6 28 L 13 28 L 14 28 L 14 27 L 14 18 L 18 18 L 18 27 L 18 28 L 19 28 L 26 28 L 27 28 L 27 27 L 27 16.4375 L 28.28125 17.71875 L 29.71875 16.28125 L 16.71875 3.28125 L 16 2.59375 z M 16 5.4375 L 25 14.4375 L 25 26 L 20 26 L 20 17 L 20 16 L 19 16 L 13 16 L 12 16 L 12 17 L 12 26 L 7 26 L 7 14.4375 L 16 5.4375 z"
    {...props}
  />
);
const InfoCircle = (props: PathProps) => (
  <React.Fragment>
    <g transform="translate(4023.905 12149.519)" {...props}>
      <circle
        sx={{
          fill: props.fill,
        }}
        cx="15"
        cy="15"
        r="15"
        transform="translate(-4023.905 -12149.519)"
      />
      <g transform="translate(-4012.351 -12143.519)">
        <path
          sx={{
            fill: props.stroke || "white",
          }}
          d="M-3910.393-12078.359h.768v2.422a12.152,12.152,0,0,1-2.119.187c-2.445,0-3.283-.908-3.283-2.888v-7.125c0-.466-.187-.582-.606-.582h-.885v-2.4h5.4v9.454C-3911.115-12078.708-3910.952-12078.359-3910.393-12078.359Zm-4.7-15.392h4.028v3h-4.028Z"
          transform="translate(3916.517 12093.751)"
        />
      </g>
    </g>
  </React.Fragment>
);
const Phone = (props: PathProps) => (
  <path
    d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
    {...props}
  />
);

const PhoneAlt = (props: PathProps) => (
  <React.Fragment>
    <g transform="translate(-236 -35)" {...props}>
      <path
        d="M340.61,46.86c51.2,0.05,92.69,41.54,92.76,92.74c-0.05,51.2-41.56,92.7-92.76,92.76
          c-51.21-0.05-92.7-41.54-92.76-92.76C247.9,88.41,289.41,46.92,340.61,46.86 M340.61,35C282.83,35,236,81.83,236,139.61
          s46.83,104.61,104.61,104.61s104.61-46.83,104.61-104.61S398.38,35,340.61,35z"
      />
      <path
        d="M398.8,165.92L398.8,165.92c-4.9-4.92-9.9-9.9-14.77-14.74l-0.5-0.5
          c-2.66-2.81-6.34-4.43-10.21-4.51c-3.89,0.07-7.57,1.72-10.24,4.55c-2.66,2.64-5.42,5.37-8.15,8.15l-0.79-0.39
          c-1.18-0.59-2.32-1.13-3.28-1.74c-8.59-5.56-16.21-12.5-22.54-20.54c-2.79-3.31-5.17-6.95-7.07-10.84
          c2.29-2.24,4.55-4.53,6.74-6.74l1.4-1.4c5.73-5.03,6.3-13.75,1.27-19.49c-0.4-0.45-0.82-0.87-1.27-1.27l-3.69-3.71l-3.75-3.77
          l-2.5-2.51l-0.17-0.17c-1.64-1.66-3.35-3.36-5.06-5.05c-2.67-2.77-6.33-4.37-10.18-4.44c-3.86,0.07-7.53,1.68-10.2,4.48
          c-1.26,1.24-2.5,2.5-3.71,3.71l-0.14,0.14c-1.73,1.74-3.69,3.74-5.58,5.58c-3.78,3.55-6.05,8.41-6.36,13.59
          c-0.33,7.21,0.93,14.4,3.69,21.06c4.99,13.01,12.21,25.06,21.34,35.58c11.96,14.32,26.82,25.95,43.6,34.12
          c7.79,4.09,16.33,6.56,25.11,7.25c0.6,0,1.18,0,1.76,0c6.38,0.22,12.53-2.43,16.74-7.24c1.68-1.87,3.59-3.73,5.42-5.58
          c0.95-0.92,2.02-1.97,3.07-3.01c5.69-5.06,6.19-13.77,1.13-19.46C399.55,166.65,399.18,166.28,398.8,165.92z M382.98,188.63
          c-2.7,3.02-6.72,4.49-10.73,3.95c-7.48-0.61-14.77-2.75-21.39-6.29c-15.56-7.57-29.35-18.34-40.45-31.62
          c-8.41-9.67-15.06-20.74-19.66-32.71c-2.28-5.33-3.34-11.11-3.11-16.9c0.14-2.76,1.33-5.37,3.35-7.27
          c2.01-1.91,3.95-3.88,5.82-5.76c1.23-1.24,2.48-2.51,3.77-3.77c0.86-0.98,2.06-1.58,3.36-1.68c1.3,0.1,2.51,0.69,3.37,1.66
          c1.66,1.62,3.33,3.31,4.98,4.96l0.1,0.1l2.55,2.57l3.53,3.54l0.39,0.39l3.53,3.54c1.93,1.36,2.38,4.02,1.02,5.95
          c-0.28,0.4-0.63,0.75-1.02,1.02l-1.28,1.3c-2.61,2.64-5.32,5.36-8.02,7.99l0,0c-2.16,2.01-2.77,5.17-1.52,7.84
          c2.34,5.36,5.44,10.35,9.22,14.81c7.01,8.87,15.43,16.52,24.93,22.65c1.4,0.88,2.79,1.56,4.18,2.22l0,0
          c0.78,0.39,1.52,0.75,2.2,1.12c1.05,0.62,2.24,0.95,3.46,0.96c1.92-0.03,3.74-0.85,5.02-2.29c3.05-3.14,6.25-6.3,9.34-9.37l0,0
          c0.85-0.98,2.04-1.58,3.33-1.69c1.29,0.11,2.5,0.71,3.35,1.69l0.27,0.25c4.92,4.9,10,9.94,14.97,14.94
          c1.93,1.36,2.38,4.02,1.02,5.95c-0.28,0.4-0.63,0.75-1.02,1.02c-0.98,0.98-2.02,2-2.94,2.9
          C386.91,184.54,384.89,186.51,382.98,188.63z"
      />
    </g>
  </React.Fragment>
);

const Spinner = (props: PathProps) => (
  <path
    d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
    {...props}
  />
);

const Star = (props: PathProps) => (
  <path
    d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
    {...props}
  />
);

const Times = (props: PathProps) => (
  <path
    d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    {...props}
  />
);

export const ICONS = {
  "chevron-down": ChevronDown,
  "chevron-up": ChevronUp,
  "chevron-right": ChevronRight,
  home: Home,
  phone: Phone,
  phoneAlt: PhoneAlt,
  infoCircle: InfoCircle,
  spinner: Spinner,
  star: Star,
  times: Times,
} as const;

export type IconName = keyof typeof ICONS;

interface IconProps extends SVGAttributes<SVGSVGElement> {
  /**
   * Text to show assistive technologies.
   * **Not** an actual `alt` attribute, because we don't render an `img`, but it serves the same role.
   */
  alt: string;
  /** Which Icon to show */
  name: IconName;
}

export type IconRef = SVGSVGElement;

/**
 * Simple graphics that make an element stand out and increase legibility at a glance.
 */
export const Icon = forwardRef<IconRef, IconProps>(
  (
    {
      name,
      alt,
      width = 32,
      height = 32,
      viewBox = "0 0 512 512",
      fill = "#fff",
      ...rest
    },
    ref
  ) => {
    const Icon = ICONS[name];
    return (
      <Fragment>
        <svg
          ref={ref}
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          viewBox={viewBox}
          focusable="false"
          role="img"
          aria-hidden={alt ? "false" : "true"}
          sx={{
            display: "inline-block",
          }}
          {...rest}
        >
          <Icon sx={{ fill }} />
        </svg>
        <span sx={{ variant: "visuallyhidden" }}>{alt}</span>
      </Fragment>
    );
  }
);

Icon.displayName = "Icon";
